import builder from '../builder';
import TaskListCheck from '../../streamline-icons/light/task-list-check.svg';

export default builder('IconTaskListCheckLight', TaskListCheck);
